import React, { FC, useEffect } from 'react'
import Section from '../../components/Layout/Section'
import { useTranslation } from 'react-i18next'
import styles from './Cgu.module.scss'

export const Cookies: FC = () => {
  const { t } = useTranslation('cookies')

  const HtmlStringComponent = ({ htmlString }: { htmlString: string }) => {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  };

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Section className={`text-align-justify ${styles.cguDetails}`} >
        <HtmlStringComponent htmlString={t('text')} />
    </Section>
);
}
export default Cookies
